import { render, staticRenderFns } from "./OperateSecurity.vue?vue&type=template&id=5153a938&scoped=true&"
import script from "./OperateSecurity.vue?vue&type=script&lang=ts&"
export * from "./OperateSecurity.vue?vue&type=script&lang=ts&"
import style0 from "./OperateSecurity.vue?vue&type=style&index=0&id=5153a938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153a938",
  null
  
)

export default component.exports